import React from 'react'

import "./Terminos.css"

const Terminos = () => {
  return (
<div className='layout-page terminos-page'>
      <h1>Términos de Servicio</h1>
      <section className="terms-section">
        <h2>Naturaleza Informativa del Sitio</h2>
        <p>
          Card Armory opera exclusivamente como un sitio web corporativo y catálogo de marca. Este sitio no procesa transacciones comerciales, pagos en línea ni ventas directas al público final.
        </p>
      </section>

      <section className="terms-section">
        <h2>Canales de Venta Autorizados</h2>
        <p>
          Todos los productos de la marca son comercializados de forma exclusiva a través de nuestra red de tiendas aliadas y distribuidores oficiales. Las compras, precios, métodos de pago y gestión de inventario deben realizarse directamente con dichos establecimientos.
        </p>
      </section>

      <section className="terms-section">
        <h2>Propiedad Intelectual</h2>
        <p>
          Todo el contenido, logotipos, gráficos, textos y el eslogan <strong>"Equipment for the Modern Adventurer"</strong> mostrados en este sitio web son propiedad exclusiva de Card Armory. Queda prohibida su reproducción total o parcial sin autorización previa.
        </p>
      </section>

      <section className="terms-section">
        <h2>Exactitud de la Información</h2>
        <p>
          Card Armory se esfuerza por mostrar especificaciones técnicas precisas de los accesorios TCG (materiales, dimensiones y compatibilidad). Sin embargo, las imágenes y descripciones son de carácter referencial y pueden presentar variaciones menores según los lotes de fabricación.
        </p>
      </section>

      <section className="terms-section">
        <h2>Limitación de Responsabilidad</h2>
        <p>
          La marca no asume responsabilidad directa por transacciones financieras, retrasos en envíos, políticas de cambio o garantías gestionadas de manera independiente por las tiendas aliadas que distribuyen los productos.
        </p>
      </section>

      <section className="terms-section">
        <h2>Modificaciones</h2>
        <p>
          Nos reservamos el derecho de actualizar o modificar en cualquier momento la información del catálogo, especificaciones de productos y estos términos sin previo aviso.
        </p>
      </section>
    </div>
  )
}

export default Terminos